import React, { useEffect, useState } from "react";
import clsx from "clsx";
import type { ISelectOption } from "components/Select";
import { SleekPicker } from "components/Sleek/SleekPicker";

interface FilterSelectProps {
  options: ISelectOption[];
  defaultId?: any;
  onChange: (option: ISelectOption) => void;
  titlePrefix?: string;
  className?: string;
  // The "all" option's id: the pill reads it muted, and a picked value clears back to it.
  mutedId?: any;
}

// A toolbar filter in the Trends pages' finish at the toolbar's size (2026-10-26: `SleekPicker`, small): a pill saying
// what it filters (`titlePrefix`) and what is picked, a compact menu under it. Hugs its content, from 150 px.
const FilterSelect = ({ options, defaultId, onChange, titlePrefix, className, mutedId }: FilterSelectProps) => {
  const [value, setValue] = useState(String(defaultId ?? options[0]?.id ?? ""));
  useEffect(() => setValue(String(defaultId ?? options[0]?.id ?? "")), [defaultId]);

  return (
    <div className={clsx("min-w-[150px] flex-shrink-0", className)}>
      <SleekPicker
        size="sm"
        // "ROAR: " / "JOOR:" — the pill sets the label apart itself
        label={(titlePrefix ?? "").replace(/[:\s]+$/, "")}
        options={options}
        value={value}
        {...(mutedId !== undefined && { mutedId: String(mutedId) })}
        onChange={(id) => {
          setValue(id);
          const option = options.find((o) => String(o.id) === id);
          if (option) onChange(option);
        }}
      />
    </div>
  );
};

export default FilterSelect;
